import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d50895a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }

import {ColumnType} from "ant-design-vue/lib/table/interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetTableBody',
  props: {
    listData: {},
    columns: {},
    rowSelection: {},
    selectRowKey: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function onChange(pagination: any, filters: any, sorter: any) {
  emit("change", pagination, filters, sorter);
}


return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      columns: _ctx.columns,
      "row-key": _ctx.selectRowKey,
      "data-source": _ctx.listData.list,
      loading: _ctx.listData.loading,
      rowSelection: _ctx.rowSelection,
      rowClassName: (_, index) => (index % 2 === 1 ? 'table-striped' : null),
      pagination: false,
      size: "small",
      onChange: onChange,
      bordered: true
    }, null, 8, ["columns", "row-key", "data-source", "loading", "rowSelection", "rowClassName"])
  ]))
}
}

})